import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import StaffCalendarViewReport from "./StaffCalendarViewReport";
import { BodyBuilder, NoPic } from "../../../../exports/Images";
import { stringToColor } from "../../../../data/Constants";
import DetailModHeader from "../../../common-components/DetailModHeader";
import { convertTo12HourFormat } from "../../../common-data/Converts";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import UploadBannerImageForm from "../banner-image/UploadBannerImageForm";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../../../components-react/ReactAlert";
import { delete_banner_image } from "../../../../data/ApiEndpoints";
import { commonPostPutApi } from "../../../../redux/reducers/commonApiSlice";
import CheckinCheckoutImg from "../checkin-checkout/CheckinCheckoutImg";
import TableSkeleton from "../../../common-components/TableSkeleton";

const StaffReport = ({ userInfoData, callFunction }) => {
  const dispatch = useDispatch();
  const { staff_atttendance_loading, staff_atttendance_report } = useSelector(
    (state) => state.api
  );
  const [allAttendanceData, setAllAttendanceData] = useState([]);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
    image: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const handleDelete = async (payload) => {
    if (payload.uid) {
      const handleConfirm = async () => {
        const method = "PUT";
        const endpoint = delete_banner_image;
        const token = userInfoData?.token;

        try {
          const result = await dispatch(
            commonPostPutApi({ method, endpoint, payload, token })
          );

          if (result?.payload?.status) {
            callFunction();
            toast.success(result?.payload?.message || "Success!");
          } else {
            const errorMessage =
              result?.error?.message || result?.payload?.message;
            toast.error(errorMessage || "Something Went Wrong!");
          }
        } catch (error) {
          console.error("Error making POST request:", error);
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    if (
      staff_atttendance_report?.status &&
      staff_atttendance_report?.data?.length > 0
    ) {
      setAllAttendanceData(staff_atttendance_report.data);
    } else {
      setAllAttendanceData([]);
    }
  }, [staff_atttendance_report]);

  const tbColumns = [
    {
      dataField: "name",
      text: "Staff",
      formatter: (_, row) => (
        <>
          <div className="emeberDetailsRowContainer">
            {row?.profile ? (
              <img
                src={row?.profile || BodyBuilder}
                alt={row?.name || "N/A"}
                className="image"
                onClick={() =>
                  row?.profile &&
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "image_view",
                    image: row?.profile,
                    rowData: row,
                  }))
                }
              />
            ) : (
              <div
                className="nameInitials"
                style={{ backgroundColor: stringToColor(row?.name || "") }}
              >
                <span className="nameLetters">
                  <span className="nameLetters">
                    {row?.name
                      ?.split(" ")
                      .map((namePart, index) =>
                        index === 0 ||
                        index === row?.name?.split(" ").length - 1
                          ? namePart.charAt(0).toUpperCase()
                          : null
                      )}
                  </span>
                </span>
              </div>
            )}
            <span className="tb-data text-start">
              {row?.name || "NA"}
              <br />
              {(row?.mobile || row?.email) && (
                <small className="lowercase">
                  {row?.mobile || ""}
                  <br />
                  {row?.email || ""}
                </small>
              )}
            </span>
          </div>

          <br />

          <span
            className="tb-data withIcon minWidth100 withPadding borderRdius64px"
            style={{
              backgroundColor:
                row?.account_type === "receptionist" ? "#EBE8FE" : "#FEF0E8",
              color: "#0C0B0B",
            }}
          >
            <div className="icon">
              {row?.account_type === "receptionist" ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <g clipPath="url(#clip0_18194_6249)">
                    <path
                      d="M8.1905 6.26968C9.46501 6.26968 10.4982 5.23649 10.4982 3.96199C10.4982 2.68749 9.46501 1.6543 8.1905 1.6543C6.916 1.6543 5.88281 2.68749 5.88281 3.96199C5.88281 5.23649 6.916 6.26968 8.1905 6.26968Z"
                      stroke="#0C0B0B"
                      strokeWidth="1.53846"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.1914 11.6547V10.5778C13.1914 9.88552 12.8068 9.19321 12.1145 8.88552C10.9606 8.19321 9.57602 7.88552 8.19141 7.80859C6.80679 7.80859 5.42218 8.19321 4.26833 8.88552C3.65294 9.19321 3.19141 9.88552 3.19141 10.5778V11.6547"
                      stroke="#0C0B0B"
                      strokeWidth="1.53846"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3.19081 15.4997L3.96004 19.3459M17.8062 15.4997L17.037 19.3459M15.4985 11.6535V11.2689C15.4985 10.6535 16.037 10.1151 16.6523 10.1151M16.6523 10.1151C17.2677 10.1151 17.8062 10.6535 17.8062 11.2689V11.6535M16.6523 10.1151V9.73047M2.80619 11.6535H18.1908C18.8062 11.6535 19.3447 12.192 19.3447 12.8074V14.3459C19.3447 14.9612 18.8062 15.4997 18.1908 15.4997H2.80619C2.19081 15.4997 1.65234 14.9612 1.65234 14.3459V12.8074C1.65234 12.192 2.19081 11.6535 2.80619 11.6535Z"
                      stroke="#0C0B0B"
                      strokeWidth="1.53846"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_18194_6249">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.5 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <path
                    d="M18.0003 6.92509C17.4692 6.27984 16.8009 5.76105 16.0441 5.40644C15.2873 5.05184 14.461 4.87032 13.6253 4.87509H3.62531C3.12803 4.87509 2.65112 5.07264 2.29949 5.42427C1.94785 5.7759 1.75031 6.25281 1.75031 6.75009V9.46884C1.74228 9.91014 1.8902 10.3401 2.16801 10.6831C2.44582 11.0261 2.83571 11.2601 3.26906 11.3438L7.95031 12.2563C8.05384 12.2766 8.15055 12.3228 8.23142 12.3906C8.31229 12.4583 8.37469 12.5455 8.41281 12.6438C8.83398 13.6788 9.55576 14.5637 10.4849 15.1842C11.4141 15.8048 12.508 16.1325 13.6253 16.1251C13.9691 16.1246 14.3121 16.0932 14.6503 16.0313C15.7491 15.8307 16.7632 15.3074 17.5635 14.5283C18.3638 13.7491 18.914 12.7493 19.1441 11.6563C19.3158 10.8322 19.3023 9.98027 19.1045 9.16202C18.9067 8.34378 18.5296 7.57972 18.0003 6.92509ZM17.9441 11.3876C17.7741 12.2405 17.351 13.0223 16.73 13.631C16.109 14.2398 15.3189 14.6472 14.4628 14.8001C13.4703 14.9866 12.4438 14.824 11.5575 14.3398C10.6712 13.8557 9.97969 13.0798 9.60031 12.1438C9.48115 11.8491 9.289 11.5895 9.04191 11.3894C8.79482 11.1893 8.50091 11.0553 8.18781 11.0001L3.50656 10.0813C3.36211 10.0534 3.23215 9.97542 3.13954 9.8611C3.04694 9.74677 2.99763 9.60344 3.00031 9.45634V6.75009C3.00031 6.58433 3.06616 6.42536 3.18337 6.30815C3.30058 6.19094 3.45955 6.12509 3.62531 6.12509H6.75031V7.37509C6.75031 7.54085 6.81616 7.69982 6.93337 7.81703C7.05058 7.93424 7.20955 8.00009 7.37531 8.00009C7.54107 8.00009 7.70004 7.93424 7.81725 7.81703C7.93446 7.69982 8.00031 7.54085 8.00031 7.37509V6.12509H13.6253C14.2706 6.12541 14.9078 6.26847 15.4913 6.544C16.0748 6.81954 16.5901 7.22074 17.0003 7.71884C17.4151 8.22434 17.7122 8.81582 17.87 9.45038C18.0278 10.0849 18.0425 10.7467 17.9128 11.3876H17.9441Z"
                    fill="#0C0B0B"
                  />
                  <path
                    d="M13.625 7.375C13.0069 7.375 12.4027 7.55828 11.8888 7.90166C11.3749 8.24504 10.9744 8.7331 10.7379 9.30411C10.5014 9.87513 10.4395 10.5035 10.56 11.1097C10.6806 11.7158 10.9783 12.2727 11.4153 12.7097C11.8523 13.1467 12.4092 13.4444 13.0153 13.565C13.6215 13.6855 14.2499 13.6236 14.8209 13.3871C15.3919 13.1506 15.88 12.7501 16.2233 12.2362C16.5667 11.7223 16.75 11.1181 16.75 10.5C16.75 9.6712 16.4208 8.87634 15.8347 8.29029C15.2487 7.70424 14.4538 7.375 13.625 7.375ZM13.625 12.375C13.2542 12.375 12.8917 12.265 12.5833 12.059C12.275 11.853 12.0346 11.5601 11.8927 11.2175C11.7508 10.8749 11.7137 10.4979 11.786 10.1342C11.8584 9.77049 12.037 9.4364 12.2992 9.17417C12.5614 8.91195 12.8955 8.73337 13.2592 8.66103C13.6229 8.58868 13.9999 8.62581 14.3425 8.76773C14.6851 8.90964 14.978 9.14996 15.184 9.45831C15.39 9.76665 15.5 10.1292 15.5 10.5C15.5 10.9973 15.3025 11.4742 14.9508 11.8258C14.5992 12.1775 14.1223 12.375 13.625 12.375Z"
                    fill="#0C0B0B"
                  />
                </svg>
              )}
            </div>
            <span className="label">
              {row?.account_type === "receptionist"
                ? "Sales Executives"
                : row?.account_type?.replace(/_/g, " ")}
            </span>
          </span>
        </>
      ),
    },
    // {
    //   dataField: "account_type",
    //   text: "Staff type",
    //   formatter: (_, row) => {
    //     return (
    //       <span
    //         className="tb-data withIcon minWidth100 withPadding borderRdius64px"
    //         style={{
    //           backgroundColor:
    //             row?.account_type === "receptionist" ? "#EBE8FE" : "#FEF0E8",
    //           color: "#0C0B0B",
    //         }}>
    //         <div className="icon">
    //           {row?.account_type === "receptionist" ? (
    //             <svg
    //               xmlns="http://www.w3.org/2000/svg"
    //               width="21"
    //               height="21"
    //               viewBox="0 0 21 21"
    //               fill="none">
    //               <g clipPath="url(#clip0_18194_6249)">
    //                 <path
    //                   d="M8.1905 6.26968C9.46501 6.26968 10.4982 5.23649 10.4982 3.96199C10.4982 2.68749 9.46501 1.6543 8.1905 1.6543C6.916 1.6543 5.88281 2.68749 5.88281 3.96199C5.88281 5.23649 6.916 6.26968 8.1905 6.26968Z"
    //                   stroke="#0C0B0B"
    //                   strokeWidth="1.53846"
    //                   strokeLinecap="round"
    //                   strokeLinejoin="round"
    //                 />
    //                 <path
    //                   d="M13.1914 11.6547V10.5778C13.1914 9.88552 12.8068 9.19321 12.1145 8.88552C10.9606 8.19321 9.57602 7.88552 8.19141 7.80859C6.80679 7.80859 5.42218 8.19321 4.26833 8.88552C3.65294 9.19321 3.19141 9.88552 3.19141 10.5778V11.6547"
    //                   stroke="#0C0B0B"
    //                   strokeWidth="1.53846"
    //                   strokeLinecap="round"
    //                   strokeLinejoin="round"
    //                 />
    //                 <path
    //                   d="M3.19081 15.4997L3.96004 19.3459M17.8062 15.4997L17.037 19.3459M15.4985 11.6535V11.2689C15.4985 10.6535 16.037 10.1151 16.6523 10.1151M16.6523 10.1151C17.2677 10.1151 17.8062 10.6535 17.8062 11.2689V11.6535M16.6523 10.1151V9.73047M2.80619 11.6535H18.1908C18.8062 11.6535 19.3447 12.192 19.3447 12.8074V14.3459C19.3447 14.9612 18.8062 15.4997 18.1908 15.4997H2.80619C2.19081 15.4997 1.65234 14.9612 1.65234 14.3459V12.8074C1.65234 12.192 2.19081 11.6535 2.80619 11.6535Z"
    //                   stroke="#0C0B0B"
    //                   strokeWidth="1.53846"
    //                   strokeLinecap="round"
    //                   strokeLinejoin="round"
    //                 />
    //               </g>
    //               <defs>
    //                 <clipPath id="clip0_18194_6249">
    //                   <rect
    //                     width="20"
    //                     height="20"
    //                     fill="white"
    //                     transform="translate(0.5 0.5)"
    //                   />
    //                 </clipPath>
    //               </defs>
    //             </svg>
    //           ) : (
    //             <svg
    //               xmlns="http://www.w3.org/2000/svg"
    //               width="21"
    //               height="21"
    //               viewBox="0 0 21 21"
    //               fill="none">
    //               <path
    //                 d="M18.0003 6.92509C17.4692 6.27984 16.8009 5.76105 16.0441 5.40644C15.2873 5.05184 14.461 4.87032 13.6253 4.87509H3.62531C3.12803 4.87509 2.65112 5.07264 2.29949 5.42427C1.94785 5.7759 1.75031 6.25281 1.75031 6.75009V9.46884C1.74228 9.91014 1.8902 10.3401 2.16801 10.6831C2.44582 11.0261 2.83571 11.2601 3.26906 11.3438L7.95031 12.2563C8.05384 12.2766 8.15055 12.3228 8.23142 12.3906C8.31229 12.4583 8.37469 12.5455 8.41281 12.6438C8.83398 13.6788 9.55576 14.5637 10.4849 15.1842C11.4141 15.8048 12.508 16.1325 13.6253 16.1251C13.9691 16.1246 14.3121 16.0932 14.6503 16.0313C15.7491 15.8307 16.7632 15.3074 17.5635 14.5283C18.3638 13.7491 18.914 12.7493 19.1441 11.6563C19.3158 10.8322 19.3023 9.98027 19.1045 9.16202C18.9067 8.34378 18.5296 7.57972 18.0003 6.92509ZM17.9441 11.3876C17.7741 12.2405 17.351 13.0223 16.73 13.631C16.109 14.2398 15.3189 14.6472 14.4628 14.8001C13.4703 14.9866 12.4438 14.824 11.5575 14.3398C10.6712 13.8557 9.97969 13.0798 9.60031 12.1438C9.48115 11.8491 9.289 11.5895 9.04191 11.3894C8.79482 11.1893 8.50091 11.0553 8.18781 11.0001L3.50656 10.0813C3.36211 10.0534 3.23215 9.97542 3.13954 9.8611C3.04694 9.74677 2.99763 9.60344 3.00031 9.45634V6.75009C3.00031 6.58433 3.06616 6.42536 3.18337 6.30815C3.30058 6.19094 3.45955 6.12509 3.62531 6.12509H6.75031V7.37509C6.75031 7.54085 6.81616 7.69982 6.93337 7.81703C7.05058 7.93424 7.20955 8.00009 7.37531 8.00009C7.54107 8.00009 7.70004 7.93424 7.81725 7.81703C7.93446 7.69982 8.00031 7.54085 8.00031 7.37509V6.12509H13.6253C14.2706 6.12541 14.9078 6.26847 15.4913 6.544C16.0748 6.81954 16.5901 7.22074 17.0003 7.71884C17.4151 8.22434 17.7122 8.81582 17.87 9.45038C18.0278 10.0849 18.0425 10.7467 17.9128 11.3876H17.9441Z"
    //                 fill="#0C0B0B"
    //               />
    //               <path
    //                 d="M13.625 7.375C13.0069 7.375 12.4027 7.55828 11.8888 7.90166C11.3749 8.24504 10.9744 8.7331 10.7379 9.30411C10.5014 9.87513 10.4395 10.5035 10.56 11.1097C10.6806 11.7158 10.9783 12.2727 11.4153 12.7097C11.8523 13.1467 12.4092 13.4444 13.0153 13.565C13.6215 13.6855 14.2499 13.6236 14.8209 13.3871C15.3919 13.1506 15.88 12.7501 16.2233 12.2362C16.5667 11.7223 16.75 11.1181 16.75 10.5C16.75 9.6712 16.4208 8.87634 15.8347 8.29029C15.2487 7.70424 14.4538 7.375 13.625 7.375ZM13.625 12.375C13.2542 12.375 12.8917 12.265 12.5833 12.059C12.275 11.853 12.0346 11.5601 11.8927 11.2175C11.7508 10.8749 11.7137 10.4979 11.786 10.1342C11.8584 9.77049 12.037 9.4364 12.2992 9.17417C12.5614 8.91195 12.8955 8.73337 13.2592 8.66103C13.6229 8.58868 13.9999 8.62581 14.3425 8.76773C14.6851 8.90964 14.978 9.14996 15.184 9.45831C15.39 9.76665 15.5 10.1292 15.5 10.5C15.5 10.9973 15.3025 11.4742 14.9508 11.8258C14.5992 12.1775 14.1223 12.375 13.625 12.375Z"
    //                 fill="#0C0B0B"
    //               />
    //             </svg>
    //           )}
    //         </div>
    //         <span className="label">
    //           {row?.account_type === "receptionist"
    //             ? "Sales Executives"
    //             : row?.account_type?.replace(/_/g, " ")}
    //         </span>
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data" style={{ width: "100px" }}>
            <small>{row?.gym_name || "NA"}</small>
          </span>
        );
      },
    },
    {
      dataField: "shift_details",
      text: "Shift 1",
      formatter: (_, row) => {
        const shiftDetails = row?.shift_details ? row.shift_details?.[0] : {};
        const startTime = shiftDetails?.start_time
          ? convertTo12HourFormat(shiftDetails.start_time)
          : "-";
        const endTime = shiftDetails?.end_time
          ? convertTo12HourFormat(shiftDetails.end_time)
          : "-";

        const attendanceDetails = shiftDetails?.attendance_details || {};
        const { checkin_image, checkout_image } = attendanceDetails;
        const checkinStatus =
          attendanceDetails?.checkin_status?.toLowerCase().replace(/ /g, "_") ||
          "";

        const checkinTime =
          attendanceDetails?.checkin_time &&
          attendanceDetails?.checkin_time !== "N/A"
            ? convertTo12HourFormat(attendanceDetails.checkin_time)
            : "";
        const checkoutTime =
          attendanceDetails?.checkout_time &&
          attendanceDetails?.checkout_time !== "N/A"
            ? convertTo12HourFormat(attendanceDetails.checkout_time)
            : "";

        const attendanceStatus = attendanceDetails?.status
          ?.replace(/ /g, "_")
          .toLowerCase();

        const checkinReport =
          attendanceDetails?.status &&
          attendanceStatus !== "n/a" &&
          attendanceStatus !== "not_checked_in"
            ? attendanceDetails?.status?.toLowerCase()
            : "";

        const checkinReportTime =
          attendanceDetails?.shift_difference &&
          attendanceDetails?.shift_difference !== "N/A" &&
          attendanceDetails?.status !== "On Time"
            ? attendanceDetails.shift_difference
            : "";

        const shiftName = shiftDetails?.shift_name || "";

        const isAbsent =
          checkinStatus === "day_off" ||
          checkinStatus === "on_leave" ||
          checkinStatus === "not_checked_in" ||
          checkinStatus === "absent";

        return (
          <div className="multi-tb-data-container minWidth220">
            {checkinStatus && (
              <small
                style={{
                  color: checkinStatus === "checked-in" ? "#09AA51" : "#CC0A39",
                }}
              >
                {checkinStatus.replace(/_/g, " ")}
              </small>
            )}

            {!isAbsent && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  rowGap: "5px",
                }}
              >
                {checkinTime && (
                  <small
                    className={`link`}
                    onClick={() =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "checkin_image",
                        image: checkin_image,
                        rowData: row,
                      }))
                    }
                  >
                    checkin - <b>{checkinTime}</b>{" "}
                    {checkinReport && (
                      <small
                        style={{
                          color:
                            checkinReport === "late" ? "#CC0A39" : "#3B66D6",
                        }}
                      >
                        ({checkinReport}{" "}
                        {checkinReportTime ? `${checkinReportTime}` : ""})
                      </small>
                    )}
                  </small>
                )}
                {/* {checkinReport && (
                  <small
                    style={{
                      color: checkinReport === "late" ? "#CC0A39" : "#3B66D6",
                    }}
                  >
                    checkin {checkinReport}
                    {checkinReportTime ? `(${checkinReportTime})` : ""}
                  </small>
                )} */}
                {checkoutTime && (
                  <small
                    className={`link`}
                    onClick={() =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "checkout_image",
                        image: checkout_image,
                        rowData: row,
                      }))
                    }
                  >
                    checkout - <b>{checkoutTime}</b>
                  </small>
                )}
              </div>
            )}

            {(startTime || endTime) && (
              <small className="underline">
                {startTime} - {endTime}
              </small>
            )}

            {shiftName && (
              <span
                className="info"
                style={{
                  padding: "5px 10px",
                  backgroundColor:
                    shiftName?.toLowerCase() === "evening"
                      ? "#4793AF"
                      : "#FF9800",
                }}
              >
                {shiftName}
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "shift_details",
      text: "Shift 2",
      formatter: (_, row) => {
        const shiftDetails = row?.shift_details ? row.shift_details?.[1] : {};
        const startTime = shiftDetails?.start_time
          ? convertTo12HourFormat(shiftDetails.start_time)
          : "-";
        const endTime = shiftDetails?.end_time
          ? convertTo12HourFormat(shiftDetails.end_time)
          : "-";

        const attendanceDetails = shiftDetails?.attendance_details || {};
        const { checkin_image, checkout_image } = attendanceDetails;
        const checkinStatus =
          attendanceDetails?.checkin_status
            ?.toLowerCase()
            ?.replace(/ /g, "_") || "";

        const checkinTime =
          attendanceDetails?.checkin_time &&
          attendanceDetails?.checkin_time !== "N/A"
            ? convertTo12HourFormat(attendanceDetails.checkin_time)
            : "";
        const checkoutTime =
          attendanceDetails?.checkout_time &&
          attendanceDetails?.checkout_time !== "N/A"
            ? convertTo12HourFormat(attendanceDetails.checkout_time)
            : "";

        const attendanceStatus = attendanceDetails?.status
          ?.replace(/ /g, "_")
          .toLowerCase();

        const checkinReport =
          attendanceDetails?.status &&
          attendanceStatus !== "n/a" &&
          attendanceStatus !== "not_checked_in"
            ? attendanceDetails?.status?.toLowerCase()
            : "";

        const checkinReportTime =
          attendanceDetails?.shift_difference &&
          attendanceDetails?.shift_difference !== "N/A" &&
          attendanceDetails?.status !== "On Time"
            ? attendanceDetails.shift_difference
            : "";

        const shiftName = shiftDetails?.shift_name || "";

        const isAbsent =
          checkinStatus === "day_off" ||
          checkinStatus === "on_leave" ||
          checkinStatus === "not_checked_in" ||
          checkinStatus === "absent";

        return (
          <div className="multi-tb-data-container minWidth220">
            {checkinStatus && (
              <small
                style={{
                  color: checkinStatus === "checked-in" ? "#09AA51" : "#CC0A39",
                }}
              >
                {checkinStatus.replace(/_/g, " ")}
              </small>
            )}

            {!isAbsent && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  rowGap: "5px",
                }}
              >
                {checkinTime && (
                  <small
                    className={`link`}
                    onClick={() =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "checkin_image",
                        image: checkin_image,
                        rowData: row,
                      }))
                    }
                  >
                    checkin - <b>{checkinTime}</b>{" "}
                    {checkinReport && (
                      <small
                        style={{
                          color:
                            checkinReport === "late" ? "#CC0A39" : "#3B66D6",
                        }}
                      >
                        ({checkinReport}:{" "}
                        {checkinReportTime ? `${checkinReportTime}` : ""})
                      </small>
                    )}
                  </small>
                )}
                {/* {checkinReport && (
                  <small
                    style={{
                      color: checkinReport === "late" ? "#CC0A39" : "#3B66D6",
                    }}>
                    checkin {checkinReport}{" "}
                    {checkinReportTime ? `(${checkinReportTime})` : ""}
                  </small>
                )} */}
                {checkoutTime && (
                  <small
                    className={`link`}
                    onClick={() =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        modName: "checkout_image",
                        image: checkout_image,
                        rowData: row,
                      }))
                    }
                  >
                    checkout - <b>{checkoutTime}</b>
                  </small>
                )}
              </div>
            )}

            {(startTime || endTime) && (
              <small className="underline">
                {startTime} - {endTime}
              </small>
            )}

            {shiftName && (
              <span
                className="info"
                style={{
                  padding: "5px 10px",
                  backgroundColor:
                    shiftName?.toLowerCase() === "evening"
                      ? "#4793AF"
                      : "#FF9800",
                }}
              >
                {shiftName}
              </span>
            )}
          </div>
        );
      },
    },
    {
      dataField: "banner_image",
      text: "Banner Image",
      formatter: (_, row) => {
        return (
          <div className="flexCenter minWidth150">
            <div className="tb-data-img">
              <img
                src={row?.banner_image || NoPic}
                alt={row?.name || "NA"}
                className="image"
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "banner_image",
                    image: row?.banner_image || NoPic,
                    rowData: row,
                  }));
                }}
              />

              <button
                type="button"
                className="abs-zoom"
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "image_view",
                    image: row?.banner_image || NoPic,
                    rowData: row,
                  }));
                }}
                disabled={!row?.banner_image}
                style={{
                  opacity: row?.banner_image ? "1" : "0.5",
                  cursor: row?.banner_image ? "pointer" : "not-allowed",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrows-fullscreen"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707"
                  />
                </svg>
                {/* <MdZoomOutMap /> */}
              </button>
              <button
                type="button"
                className="abs-zoom abs-del"
                onClick={() => {
                  const uidFilter = {
                    uid: row?.banner_id || "",
                  };

                  handleDelete(uidFilter);
                }}
                disabled={!row?.banner_image}
                style={{
                  opacity: row?.banner_image ? "1" : "0.5",
                  cursor: row?.banner_image ? "pointer" : "not-allowed",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash3-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                </svg>
                {/* <MdOutlineDeleteOutline /> */}
              </button>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            account_type="button"
            className="actionBtn icon view withText"
            disabled={false}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                rowData: row,
              }))
            }
          >
            view details
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "image_view" ||
            modValues.modName === "checkin_image" ||
            modValues.modName === "checkout_image" ||
            modValues.modName === "banner_image"
              ? "mod-width-50p"
              : ""
          } ${
            modValues.modName === "banner_image"
              ? "mealsModalContainer addIngModal"
              : ""
          }`}
        >
          {modValues.modName === "banner_image" ? null : modValues.modName ===
            "view_details" ? (
            <DetailModHeader info={modValues.rowData} onClose={onCloseModal} />
          ) : (
            <ModalHeadAndClose
              title={
                modValues.modName === "image_view" ||
                modValues.modName === "checkin_image" ||
                modValues.modName === "checkout_image"
                  ? `${modValues.rowData?.name} - ${modValues.modName?.replace(
                      /_/g,
                      " "
                    )}`
                  : modValues.modName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            />
          )}

          {modValues.modName === "view_details" ? (
            <StaffCalendarViewReport
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "image_view" ? (
            <div className="discussionModalMessage mt30">
              <img
                src={modValues.image || NoPic}
                alt="profile"
                style={{
                  width: "400px",
                  height: "400px",
                }}
              />
            </div>
          ) : modValues.modName === "checkin_image" ||
            modValues.modName === "checkout_image" ? (
            <CheckinCheckoutImg
              rowData={modValues.rowData}
              modName={modValues.modName}
            />
          ) : modValues.modName === "banner_image" ? (
            <UploadBannerImageForm
              isEdit={modValues.rowData?.banner_image}
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              callFunction={callFunction}
            />
          ) : null}
        </div>
      </Modal>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt-0 mb30">
        {staff_atttendance_loading ? (
          <TableSkeleton columns={12} rows={20} />
        ) : (
          <PaymentLinkTable
            tableData={allAttendanceData}
            tableColumns={tbColumns}
            // tablePagination={allDatas.pagination}
            // isPage={isPage}
            // setIsPage={(value) => setIsPage(value)}
            // pageLimit={pageLimit}
            // setPageLimit={setPageLimit}
            isFirstColSticky={true}
          />
        )}
      </div>
    </>
  );
};

export default StaffReport;
